import Vue from "vue";
import FavoriteAppsWidget from "./components/FavoriteApps.vue";
import store from './store/index';
import VueCompositionAPI from "@vue/composition-api";

Vue.config.productionTip = false;
Vue.use(VueCompositionAPI)

let FavoriteAppsWidgets = document.querySelectorAll('widget-favorite-apps');
if (FavoriteAppsWidgets.length) {
    FavoriteAppsWidgets.forEach(el => {
        new Vue({
            el: el,
            store,
            render(h: any) {
                let language = this.$el.attributes.getNamedItem('language');
                let overviewUrl = this.$el.attributes.getNamedItem('overviewUrl');
                let labels = this.$el.attributes.getNamedItem('labels');
                let editMode = this.$el.attributes.getNamedItem('editMode');

                return h(FavoriteAppsWidget, {
                    props: {
                        configRaw: {
                            language: language ? language.value : null,
                            overviewUrl: overviewUrl ? overviewUrl.value : null,
                            labels: labels ? JSON.parse(labels.value) : null,
                            editMode: editMode ? (editMode.value == 'false' ? false : true) : null
                        }
                    }
                });
            }
        });
    });
}
